import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const StudentsInput = ({ helpText = null }) => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("ofStudents")}
      placeholder={t("ofStudents")}
      id="num_students"
      type="text"
      autoComplete="students"
      required={false}
      helperText={helpText}
      checkType="number"
      attr={{ maxLength: 5 }}
    />
  );
};
export default StudentsInput;